// src/redux/slices/contractSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  contractName: '',
};

const contractSlice = createSlice({
  name: 'contract',
  initialState,
  reducers: {
    setContractName: (state, action) => {
      state.contractName = action.payload;
    },
  },
});

export const { setContractName } = contractSlice.actions;

export default contractSlice.reducer;
